import { AidaService, ELlmResponseType } from '@adaptiva/ai/common';
import { TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { ErrorHandlerService } from '@adaptiva/core/error-handler';
import { Licensing } from '@adaptiva/core/licensing';
import { ITreeIcon } from '@adaptiva/core/trees';
import { IsLicensedPipe } from '@adaptiva/data-service';
import { BUBBLE_REGISTRATIONS } from '@adaptiva/widgets/chat';
import { IconComponent } from '@adaptiva/widgets/icon';
import { MenuComponentModule } from '@adaptiva/widgets/menu';
import { TabsContainerComponent } from '@adaptiva/widgets/tabs';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { DashboardBubbleComponent } from '../dashboard-bubble';
import { LlmFreeTrialComponent } from '../free-trial';
import { LlmChatComponent } from '../llm-chat';
import { LlmForksComponent } from '../llm-forks';
import { LlmHistoryComponent } from '../llm-history';
import { LlmSwitchComponent } from '../llm-switch';

@Component({
	selector: 'ada-llm',
	templateUrl: './llm.component.html',
	styleUrl: './llm.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		AsyncPipe,
		IconComponent,
		IsLicensedPipe,
		LlmChatComponent,
		LlmForksComponent,
		LlmFreeTrialComponent,
		LlmHistoryComponent,
		LlmSwitchComponent,
		MenuComponentModule,
		TabsContainerComponent,
		TemplateMarkerDirectiveModule
	],
	host: {
		'[class.ada-full-size]': 'true',
		'[class.ada-display-block]': 'true',
	},
	providers: [
		{
			provide: BUBBLE_REGISTRATIONS,
			useValue: new Map([
				[ELlmResponseType.DASHBOARD, DashboardBubbleComponent]
			])
		}
	]
})
export class LlmComponent {

	protected readonly aida: AidaService = inject(AidaService);

	protected readonly errorHandler: ErrorHandlerService = inject(ErrorHandlerService);

	// keep up to date with LlmDisplayService.DisplayedTabs
	protected readonly tabNames: string[] = [
		'Chat',
		'Forks',
		'History'
	];

	protected readonly aiProductName: string = Licensing.Products.AddOns.AI;

	protected readonly tabIcons: Signal<ITreeIcon[]> = computed(() => [
		{
			icon: 'faCommentAlt',
			color: 'primary',
			tooltip: `${this.aida.displayName()} Chat`
		},
		{
			icon: 'faCodeFork',
			color: 'primary',
			tooltip: `${this.aida.displayName()} Conversation Forks`
		},
		{
			icon: 'faClockOutline',
			color: 'primary',
			tooltip: `${this.aida.displayName()} Chat History`
		},
	]);

	protected startConversation(): void {
		this.aida.startConversation().subscribe({
			error: (e: Error) => {
				this.errorHandler.defaultErrorHandler(e, 'LlmComponent.startConversation');
			}
		});
	}

}
